import { LightBulb, SunIcon, MoonIcon } from "../icons/iconRepo";

export const themeIcons = {
  dark: <MoonIcon />,
  light: <LightBulb />,
  solarized: <SunIcon />,
};
